import { css } from "styled-components";
import { fontColorMixin } from "../fontColorMixin";
/** @class SpinnerMixin */

/** @method */

export var SpinnerMixin = function SpinnerMixin(props) {
  return css(["@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}animation:spin 0.5s linear infinite;", ""], fontColorMixin(props));
};